import { Link } from "react-router-dom";
import React from "react";
const BoekingenMenu = ({ token, username, isActive, onToggle }) => {
  if (username.bedrijf && username.bedrijf.modules.includes("ervaringen")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker" || token.role === "ervaringeigenaar") {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon">
              <i className="fa fa-warehouse"></i>
            </span>
            <span className="menu-text">Beheer Boekingen</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}>
              <i className="fas fa-chevron-right"></i>
            </span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/boekingen" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-warehouse"></i>
                </span>
                <span className="menu-text">Nieuwe Boekingen</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/boekingen/financieel" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-euro"></i>
                </span>
                <span className="menu-text">Financieel</span>
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default BoekingenMenu;
